var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LengthWithLVS, MessagePlatformEnum } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsEnum, IsIn, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { UserExposeGroup } from '../interface/user-expose-group';
import { UserStateEnum } from '../interface/user-state.enum';
import { UserTypeEnum } from '../interface/user-type.enum';
import { ReadUserSubscriptionDto } from './ReadUserSubscriptionDto';
let ReadBaseUserDto = class ReadBaseUserDto {
    isTemporary() {
        return UserTypeEnum.TEMPORARY === this.type;
    }
    isGuest() {
        return UserTypeEnum.GUEST === this.type;
    }
    isRegistered() {
        return this.isAuthenticated();
    }
    isAuthenticated() {
        return UserTypeEnum.AUTHENTICATED === this.type;
    }
    isMerchant() {
        return UserTypeEnum.MERCHANT_USER === this.type;
    }
    isActive() {
        return UserStateEnum.ACTIVE === this.state;
    }
    isBlocked() {
        return UserStateEnum.BLOCKED === this.state;
    }
    isSuspended() {
        return UserStateEnum.SUSPENDED === this.state;
    }
    isDeleted() {
        return UserStateEnum.DELETED === this.state;
    }
};
__decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadBaseUserDto.prototype, "messagePlatform", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'ref to store.merchantId', example: 'ddfb5654-7fe1-40de-8be8-041116c8f267' }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.SEARCH] }),
    __metadata("design:type", String)
], ReadBaseUserDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ example: '000047856800482' }),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.CONFIGURABLE] }),
    LengthWithLVS(1, 50, { always: true }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.SEARCH_RESULT] }),
    __metadata("design:type", String)
], ReadBaseUserDto.prototype, "userId", void 0);
__decorate([
    IsIn([UserTypeEnum.GUEST], { groups: [UserExposeGroup.PATCH] }),
    IsOptional({ groups: [UserExposeGroup.PATCH] }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadBaseUserDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => String, enum: UserStateEnum, example: UserStateEnum.ACTIVE }),
    IsOptional({ groups: [UserExposeGroup.PATCH] }),
    IsEnum(UserStateEnum, { always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.PATCH, UserExposeGroup.SEARCH_RESULT] }),
    __metadata("design:type", String)
], ReadBaseUserDto.prototype, "state", void 0);
__decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadBaseUserDto.prototype, "stateReason", void 0);
__decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Object)
], ReadBaseUserDto.prototype, "stateUpdatedAt", void 0);
__decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.CREATE, UserExposeGroup.CONFIGURABLE, UserExposeGroup.READ] }),
    __metadata("design:type", Object)
], ReadBaseUserDto.prototype, "profile", void 0);
__decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], ReadBaseUserDto.prototype, "isEmailConfirmed", void 0);
__decorate([
    ApiProperty({ type: () => ReadUserSubscriptionDto }),
    Type(() => ReadUserSubscriptionDto),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    __metadata("design:type", ReadUserSubscriptionDto)
], ReadBaseUserDto.prototype, "subscription", void 0);
ReadBaseUserDto = __decorate([
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.PATCH] })
], ReadBaseUserDto);
export { ReadBaseUserDto };
//# sourceMappingURL=ReadBaseUserDto.js.map